import { Switch, Route } from 'react-router-dom';
import UsersList from './UsersList';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/users">
        <UsersList />
      </Route>
    </Switch>
  );
}
